import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const DesignAndMaterial = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section">
          <AnimateOnScroll animationType="slideup">
            <video autoPlay muted loop style={{ width: "100%" }}>
              <source
                src="/images/videos/Oasis Interior.mp4"
                type="video/mp4"
              />
            </video>
          </AnimateOnScroll>
        </Row>
        <Row className="section ">
          <Col md={12} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideRight">
              <h2>{t("design_main_title")}</h2>
              <p>{t("design_main_p")}</p>
            </AnimateOnScroll>
          </Col>
          </Row>
          <Row className="section equal-height-row">
          <Col md={6} className="d-flex">
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/dream_team_02.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
          <Col md={6} className="d-flex">
            <AnimateOnScroll animationType="slideRight">
              <img
                src="/images/DDK_9133.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
        </Row>

        <Row className="section">
          <Col md={5} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideUp">
              <h2>{t("design_materials_title")}</h2>
              <p>{t("design_materials_p")}</p>
            </AnimateOnScroll>
          </Col>
          <Col md={7}>
            <AnimateOnScroll animationType="slideup">
              <Row>
                <img
                  src="/images/new_33.jpg"
                  alt="One Oasis"
                  className="fullimg"
                />
              </Row>
            </AnimateOnScroll>
          </Col>
        </Row>

        <Row className="section ">
          <Col md={12} className="d-flex flex-column justify-content-center">
            <AnimateOnScroll animationType="slideRight">
              <h2>{t("design_brands_title")}</h2>
              <p>{t("design_brands_p")}</p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row className="section equal-height-row">
          <Col md={6} className="d-flex">
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/sky_06.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
          <Col md={6} className="d-flex">
            <AnimateOnScroll animationType="slideRight">
              <img
                src="/images/sky_04.jpg"
                alt="One Oasis"
                className="fullimg"
              />
            </AnimateOnScroll>
          </Col>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default DesignAndMaterial;
